import React from 'react';
import Table from 'react-bootstrap/Table';
import PassengerName from '../assignedUser/PassengerName';
import { useNavigate } from "react-router-dom";
import { Base64 } from 'js-base64';
import { Avatar } from '@mui/material';
import {dateFormat} from "../../utils";
import { BASE_API_URI } from '../../constant';

function DriverTable({tableData}) {
//    {console.log(tableData)}
  const navigate = useNavigate();
   const handleEditClick=(id)=>{
    //alert(id);
    navigate(`/home/officeAdmin/edit/${id}`);
   }
   {console.log('tableData',tableData)}
  return (
    <Table striped bordered hover className='tbl-require'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Driver Name</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Cell Phone</th>
                    <th>UMPI No.</th>
                    {/* <th>User Name</th> */}
                    <th>Expiry of DL</th>
                    {/* <th>Address</th> */}
                    <th style={{textAlign:'center'}}>Action</th>
                </tr>
            </thead>
            <tbody>
            { tableData && tableData.length > 0 ? (
            tableData.map((details,index)=>(
                <tr key={index}>
                    <td>{index+1}</td>
                    <td>
                     <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar alt={details.driver_name}  style={{ marginRight: '10px' }} />
                         <a href={details.driver_details?.user_role == 2 ? `/home/profile/myProfile` : `/home/driver/profile/id?profilId=${Base64.encode(details?.driver?.driver_id || details.user_id )}`} // Replace with the correct route
                            target="_blank" // Open in a new tab
                            onClick={() => localStorage.setItem('activeMenu', 'Driver List')} 
                            rel="noopener noreferrer" // Security best practice
                            style={{ textDecoration: 'none', color: 'rgb(49, 135, 111)' }} // Inherit color and remove underline
                        >
                           {details.driver_name ? details.driver_name : details.full_name}
                        </a>
                     </div>
                        
                        </td>
                    <td>{details.driver_details?.user_role != 2 ?details.first_name : <span style={{color:'grey'}}>N/A</span>}</td>
                    <td>{details.driver_details?.user_role != 2 ?details.last_name : <span style={{color:'grey'}}>N/A</span>}</td>
                    <td>{details.driver_details?.user_role != 2 ? details?.mobile_no : <span style={{color:'grey'}}>N/A</span>}</td>
                    <td>{details.driver_details?.user_role != 2 ? details?.driver?.umpi_no : <span style={{color:'grey'}}>N/A</span>}</td>
                    {/* <td>{details?.login_user_name}</td> */}
                    <td>{details.driver_details?.user_role != 2 ? dateFormat(details?.driver?.lisence_expiry_date) : <span style={{color:'grey'}}>N/A</span>}</td>
                    {/* <td>{details.driver_address}</td> */}
                    
                    {/* <PassengerName passengerNames={details.passenger_names} ids={details.passenger_ids} /> */}
                    <td style={{textAlign:'center',cursor:'pointer'}}>
                        {
                            details.driver_details?.user_role != 2 ?
                        
                        <><i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details.user_id)}></i></> :''
}
                   </td>
                </tr> 
                        ))
                    ) : (
                        <tr>
                             <td colSpan="8" style={{ textAlign: 'center' }}>No records found</td>
                        </tr>
                    ) } 
            </tbody>
    </Table>
  )}

export default DriverTable